import './css/index.css';
import 'swiper/css/bundle';
import './css/theme.css';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { AuthProvider } from './contexts/auth.context';
import { IncentiveContextProvider } from './contexts/incentive.context';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <>
    <BrowserRouter>
      <AuthProvider>
        <IncentiveContextProvider>
          <App />
        </IncentiveContextProvider>
      </AuthProvider>
    </BrowserRouter>
  </>
  // </React.StrictMode >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
